import React, { useState, useEffect, useRef } from "react";
import SubCabecera from "./components/SubCabecera";
import SubFilterSearch from "./components/SubFilterSearch";
import SubCursos from "./components/SubCursos/SubCursos";
import InfoProgress from "./components/SubProgreso/components/BoxProgress/components/CardProgress/components/InfoProgress";
import ContenedorCarrusel from "../../../../components/ContenedorCarrusel/ContenedorCarrusel";
import useTokenValidation from "../../../../hooks/useTokenValidation";
import { getProgreso } from "./service/serviceInfoProgres";

export default function Home() {
  const [vCursoFiltro, setvCursoFiltro] = useState([]);
  const [lastSearchText, setLastSearchText] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const [progreso, setProgreso] = useState(null);
  const [loadingPerfil, setLoadingPerfil] = useState(true);
  const [errorPerfil, setErrorPerfil] = useState(null);
  const [numTotal, setNumTotal] = useState(null);

  const scrollRef = useRef(null);
  const { tokenEntity } = useTokenValidation();

  useEffect(() => {
    if (!tokenEntity.isValidando) {
      const mFetchProgreso = () => {
        getProgreso(tokenEntity.token)
          .then((response) => {
            if (response.ok) return response.json();
            switch (response.status) {
              case 400:
                throw new Error("ERR_VALIDATION");
              case 401:
                throw new Error("ERR_UNAUTHORIZED");
              case 500:
                throw new Error("ERR_SERVER");
              default:
                throw new Error("ERR_UNKNOWN");
            }
          })
          .then((result) => {
            if (result?.detail?.acción === "CURSOS_EN_PROGRESO_OBTENIDOS") {
              setProgreso(result.detail);
              setNumTotal(result.detail.datos.num_total_progreso);
            }
          })
          .catch((error) => {
            if (error.message !== "ERR_ME") {
              setErrorPerfil("Error en la conexión con el servidor");
            }
          })
          .finally(() => {
            setLoadingPerfil(false);
          });
      };

      mFetchProgreso();
    }
  }, [tokenEntity.isValidando]);

  return (
    <div className="home-contenido-h" ref={scrollRef}>
      <SubCabecera scrollRef={scrollRef} />
      <div className="home-info">
        <SubFilterSearch
          setvCursoFiltro={setvCursoFiltro}
          setLastSearchText={setLastSearchText}
          setHasSearched={setHasSearched}
        />
        <SubCursos
          vCursoFiltro={vCursoFiltro}
          lastSearchText={lastSearchText}
          hasSearched={hasSearched}
        />
        <div className="home-linea" />
        <div className="home-info-progreso" data-figma-id="810:15860">
          <div className="home-info-progreso-header" data-figma-id="811:15096">
            <div
              className="home-info-progreso-titulo"
              data-figma-id="811:15097"
            >
              <p
                className="home-info-progreso-titulo-texto"
                data-figma-id="811:15098"
              >
                Mi Progreso
              </p>
              <div
                className="home-info-progreso-numero"
                data-figma-id="811:15099"
              >
                <p
                  className="home-info-progreso-numero-texto"
                  data-figma-id="811:15100"
                >
                  {numTotal}
                </p>
              </div>
            </div>
          </div>
          <div
            className="home-info-progreso-tarjetas-progreso-curso"
            data-figma-id="811:15104"
          >
            <ContenedorCarrusel>
              {loadingPerfil && <p>Cargando...</p>}
              {errorPerfil && <p>{errorPerfil}</p>}
              {progreso &&
                progreso.datos.progreso.map((curso) => (
                  <InfoProgress curso={curso} key={curso.id} />
                ))}
            </ContenedorCarrusel>
          </div>
        </div>
      </div>
    </div>
  );
}
